import { SiteFooter } from '../SiteFooter';

export default function CreatorFooter() {
  return (
    <>
      {/* Creator Section - Slightly darker background, more spacing from footer */}
      <section className="py-16 lg:py-20 px-4 sm:px-6 lg:px-8 relative z-10" style={{ background: '#F0EBE3' }}>
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-col sm:flex-row items-center gap-6 sm:gap-8">
            <img loading="lazy" 
              src="/images/6b54ea3e-c64e-4b46-bcbc-18b1e1f2b125.jpeg"
              alt="Dove in Mexico"
              className="w-32 h-32 sm:w-40 sm:h-40 rounded-2xl object-cover shadow-lg flex-shrink-0"
            />
            <div>
              <p className="font-body text-base leading-relaxed" style={{ color: '#5D5A6B' }}>
                I built these tools to take control of my income, move to Mexico, and build a life on my own terms. One relay at a time.
              </p>
              <p className="font-body text-base font-bold mt-3" style={{ color: '#2A1E5C' }} data-testid="im-footer-founder-name">
                Shari Dove Shepard, Founder
              </p>
              <a 
                href="/about"
                className="inline-flex items-center gap-2 mt-4 font-body text-sm font-medium transition-opacity hover:opacity-80"
                style={{ color: '#2A1E5C' }}
              >
                Read my story <span className="text-lg">→</span>
              </a>
            </div>
          </div>
        </div>
      </section>

      <SiteFooter />
    </>
  );
}
